import { Modal, message } from "antd";
import { Trans } from "react-i18next";
import { t } from "i18next";
import CommonButton from "@components/CommonButton";
import { IconNotice } from "@icons/index";
import { useAtom } from "jotai";
import { notificationModalAtom } from "@src/jotai/notification";
import { requestNotificationPermission } from "@utils/notification";

const GlobalChromeNotifyPermission = () => {
  const [state, setState] = useAtom(notificationModalAtom);

  const close = (runCallback = true) => {
    const onComplete = state.onComplete;
    setState({ open: false });
    if (runCallback) onComplete?.();
  };

  const handleConfirm = async () => {
    const onComplete = state.onComplete;
    setState({ open: false });

    const permission = await requestNotificationPermission();

    if (permission === "granted") {
      message.success(t("Notification permission granted"));
    } else if (permission === "denied") {
      message.info(t("You can still generate videos, but won't receive browser notifications"));
    }

    onComplete?.();
  };

  if (!state.open) return null;

  return (
    <Modal
      open={state.open}
      centered
      closable={true}
      onCancel={() => close()}
      width={480}
      footer={
        <div className="flex justify-end gap-[12px]">
          <CommonButton onClick={() => close()}>
            <Trans>No thanks</Trans>
          </CommonButton>
          <CommonButton type="primary" onClick={handleConfirm}>
            <Trans>Notify me</Trans>
          </CommonButton>
        </div>
      }
    >
      <div className="flex flex-col items-center relative">
        {/* 图标 */}
        <div className="w-[56px] h-[56px] rounded-full bg-kds-bg-overlay flex items-center justify-center my-[8px]">
          <IconNotice className="w-[32px] h-[32px] text-kds-accent-fg" />
        </div>

        {/* 标题 */}
        <div className="text-kds-fg font-semibold text-[16px] mb-[4px]">
          <Trans>Don't wait around!</Trans>
        </div>

        {/* 描述 */}
        <div className="text-kds-fg text-[14px] text-center mb-[16px] max-w-[400px]">
          <Trans>
            Enable notifications, and we'll ping you the moment your video is ready. Feel free to browse other tabs
            while we work.
          </Trans>
        </div>

        <div className="h-px bg-kds-border absolute bottom-0 -left-[24px] -right-[24px]"></div>
      </div>
    </Modal>
  );
};

export default GlobalChromeNotifyPermission;
